<template>
  <svg
    class="noimage"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="miter"
  >
    <polygon
      points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"
    ></polygon>
    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
    <line
      x1="6.99"
      y1="7"
      x2="7"
      y2="7"
      stroke-linecap="round"
      stroke-width="2"
    ></line>
  </svg>
</template>

<script>
export default {
  name: 'NoImage',
};
</script>

<style lang="scss" scoped>
.noimage {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
